import {Component, Input} from '@angular/core';

@Component({
    selector: 'employee-info-hint',
    templateUrl: './info-hint.component.html',
    styleUrls: ['./info-hint.component.less']
})
export class InfoHintComponent {
    @Input() infoText = '';
    @Input() isHTML = false;
}
